import React from 'react'
import Box from '@mui/material/Box'
import { FORM_ACTION_BUTTON_BASE_SX } from './BottomButtonGroup'

// 필터와 테이블 사이의 다운로드/업로드/Add 버튼에 사용한다.
export const LIST_TABLE_TOOLBAR_BUTTON_SX = {
    ...FORM_ACTION_BUTTON_BASE_SX,
    height: 34,
    minWidth: 96,
    px: 1.5,
}

// 목록 액션 영역은 좌우 버튼 그룹이 줄바꿈되어도 간격이 유지되도록 한다.
const toolbarSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    mt: -0.5,
    mb: 1.5,
    minHeight: 34,
    flexWrap: 'wrap',
}

// 좌측/우측 버튼 묶음은 같은 gap과 vertical alignment를 공유한다.
const groupSx = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
}

// 목록 필터와 테이블 사이 액션 버튼의 좌우 배치와 간격을 공통으로 맞춘다.
export default function ListTableToolbar({ left, right, sx }) {
    if (!left && !right) {
        return null
    }

    return (
        <Box sx={{ ...toolbarSx, ...sx }}>
            <Box sx={groupSx}>{left}</Box>
            <Box sx={{ ...groupSx, ml: 'auto' }}>{right}</Box>
        </Box>
    )
}
